import Head from 'next/head';

import { founders } from 'templates/AboutUs/containers/Founders/data';

import { Header } from 'components/Header';

import Founders from './containers/Founders';
import { ChiSiamoHero } from './containers/Hero';
import ScientificCommitee from './containers/ScientificCommitee';
import Values from './containers/Values';
import { values } from './containers/Values/data';

const AboutUs: React.FC = () => {
  return (
    <>
      <Head>
        <title key="title">Chi siamo: la nostra storia | Lami</title>

        <meta
          key="description"
          name="description"
          content="Lami è una start-up innovativa che offre supporto con servizi di assistenza istantanea attraverso chat, video consulti medici, esami e visite a domicilio."
        />
      </Head>

      <Header />

      <ChiSiamoHero nextSectionId="values-section" />

      <Values values={values} />

      <ScientificCommitee sectionToScroll="founders" />

      <Founders founders={founders} />
    </>
  );
};

export default AboutUs;
